import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {AlertType} from "../model/enum/alert.enum";
import {MessageBus} from "./messageBus";

export class ConfigRequestService {

    public async getConfigsFromAPI(baseURL: string, configAppendix: string) {
        const configURL: string = `${baseURL}/${configAppendix}`;
        const configs: any = await this.get(configURL);
        return configs.data;
    }

    private async get(url:string){
        let result: AxiosResponse<any>;
        try {
            result = await axios.get(url);
            return result;
        } catch (e) {
            this.handleError(e);
            return false;
        }
    }
    public handleError(e){
        console.error(e);
        MessageBus.$emit(AlertType[AlertType.error], e.message);
    }
}